import Delegate from "//okr-qa.ovh/cdn/shop/t/2/assets/ftdomdelegate.min.js?v=85864865866317895671655307500";
import {ToggleElem} from "//okr-qa.ovh/cdn/shop/t/2/assets/helpers.js?v=55600738155002914361784881886";
export class LandingVideoSection extends HTMLElement {

  connectedCallback() {
    this._attachListeners();
  }

  _attachListeners() {
    new Delegate(this).on('click', '[data-action="toggle-video"]', this._toggleVideo.bind(this));
  }

  /**
   * Toggle video
   */
  _toggleVideo(e, target) {
    if (e) e.preventDefault();

    let videoContainer = this.querySelector('#'+target.getAttribute('aria-controls'));
    let video = videoContainer.querySelector('video');
    let videoPaused = video.paused;

    if (video){
      if (videoPaused) {
        video.play();
      } else {
        video.pause();
      }
      ToggleElem.toggleElement(e, target, 'overlay');
    }
  }

}
try {
  window.customElements.define('landing-video-section', LandingVideoSection);
} catch(e) {}